<template>
  <div class="bg-white">
    <div class="p-6 shadow-border-b">
      <p class="font-bold text-lg mb-6">Info</p>
      <div class="flex justify-center items-start gap-6">
        <div class="w-1/5">
          <TextField type="text" label="ID" v-model="id" disabled />
        </div>
        <div class="w-4/5">
          <TextField type="text" label="Nama Cost Mapping" placeholder="Masukan nama cost mapping" v-model="payloads.name" :error="errors['name']" />
        </div>
      </div>
    </div>
    <div class="flex justify-end gap-6 p-6">
      <Button :buttonText="isDuplicate ? 'Duplikasi' : 'Simpan'" type="primary" @action="save()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'
const CONFIG = {
  name: 'Nama'
}
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
    // CirclePlus: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/CirclePlus')
  },
  data() {
    return {
      id: '00',
      errors: [],
      payloads: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('partner', ['costMappingDetail']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    costMappingId() {
      return this.$route.params.id
    },
    isDuplicate() {
      return this.$route.path.indexOf('duplicate') != -1
    }
  },
  mounted() {
    if (this.isDuplicate) {
      this.getCostMappingInfo()
    }
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    ...mapActions('partner', ['createCostMapping', 'getCostMappingDetail', 'duplicateCostMapping']),
    getCostMappingInfo() {
      this.showLoading()
      this.getCostMappingDetail({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId
      }).then(res => {
        const result = res.data.data
        this.hideLoading()
        this.id = result.id
        this.payloads.name = result.name + ' (duplicate)'
      })
    },
    validForm() {
      const error = isNotEmptyError(this.payloads)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    },
    save() {
      let self = this
      if (this.validForm()) {
        if (this.isDuplicate) {
          this.showLoading()
          this.duplicateCostMapping({
            partnerId: this.partnerId,
            costMappingId: this.costMappingId,
            payloads: {
              cost_mapping_name: self.payloads.name
            }
          }).then(res => {
            this.hideLoading()
            this.setToast({
              options: {
                type: 'success',
                duration: 2000,
                primaryText: 'Duplikasi Cost Mapping Berhasil',
                secondaryText: 'Data telah kami simpan',
                callback: this.handleCallback(res.data.data.id)
              }
            })
          })
        } else {
          this.showLoading()
          this.createCostMapping({
            partnerId: this.partnerId,
            payloads: {
              cost_mapping_name: this.payloads.name
            }
          }).then(res => {
            this.hideLoading()
            this.setToast({
              options: { type: 'success', duration: 2000, primaryText: 'Penambahan Cost Mapping Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback(res.data.data.id) }
            })
          })
        }
      }
    },
    handleCallback(id) {
      this.$router.push(`/package/cost-mapping/detail/${id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  min-height: 480px;
}
</style>
